import { ReactComponent as NotFound } from '../../assets/images/svg/404.svg';
import { ReactComponent as BGLeft } from '../../assets/images/svg/left-side-background.svg';
import { ReactComponent as BGRight } from '../../assets/images/svg/right-side-background.svg';
import { useNavigate } from 'react-router-dom';
import { NotFoundContainer } from './style';
import { useIntl } from 'react-intl';

export default function NoMatch() {

  const { formatMessage } = useIntl();

  const navigate = useNavigate();
  return (
    <NotFoundContainer>
      <div className="img-container">
        <BGRight />
        <NotFound />
        <BGLeft />
      </div>
      <label>{formatMessage({id:"title404"})}</label>
      <span>{formatMessage({id:"desc404"})}</span>
      <button onClick={() => navigate('/appointments')}>{formatMessage({id:"btn404"})}</button>
    </NotFoundContainer>
  );
}
